import { render, staticRenderFns } from "./day-filter.vue?vue&type=template&id=60c42c1e"
import script from "./day-filter.vue?vue&type=script&lang=js"
export * from "./day-filter.vue?vue&type=script&lang=js"
import style0 from "./day-filter.vue?vue&type=style&index=0&id=60c42c1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./day-filter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports